import { render } from "./cockpitTreeStarGroupPaperMaking.vue?vue&type=template&id=c28493e4&scoped=true"
import script from "./cockpitTreeStarGroupPaperMaking.vue?vue&type=script&lang=js"
export * from "./cockpitTreeStarGroupPaperMaking.vue?vue&type=script&lang=js"

import "./cockpitTreeStarGroupPaperMaking.vue?vue&type=style&index=0&id=c28493e4&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c28493e4"]])

export default __exports__